import React from 'react';
import SideMenu from '../side-menu/sideMenu';
import Header from '../header/header';
import { Outlet } from 'react-router-dom';
import './main.css';
import company from '../../assets/images/teamleasecompany.png';

import IdleTimerComponent from '../IdleTimerComponent'
class Main extends React.Component
{
    constructor()
    {
        super();
        this.state = {};
    }

    toggleChange = () => {
        // add hovered class to selected list item
        let list = document.querySelectorAll(".side-menu-navigation li");
    
        function activeLink() {
        list.forEach((item) => {
            item.classList.remove("hovered");
        });
        this.classList.add("hovered");
        }
    
        list.forEach((item) => item.addEventListener("mouseover", activeLink));
    
        // Menu Toggle
        let toggle = document.querySelector(".toggle");
        let navigation = document.querySelector(".side-menu-navigation");
        let main = document.querySelector(".main");
    
        toggle.onclick = function () {
        navigation.classList.toggle("active");
        main.classList.toggle("active");
        };
    }

    // changeIconName = () => {
    //     let list = document.querySelectorAll(".ionicon s-ion-icon");
    //     console.log("list", list);
    // }

    adjustZoom = () => {
        document.body.style.zoom = '75%'; // Adjust the zoom level here
        document.body.style.backgroundColor = '#E5EBF7'; // Ensure the body has the correct background color

        // Ensure the html element also has the correct background color
        document.documentElement.style.backgroundColor = '#E5EBF7';
    }
    componentDidMount()
    {
        this.toggleChange();
        this.adjustZoom();
        // this.changeIconName();
    }

    render()
    {
        return (
            <div className="side-menu-container">
                <SideMenu />
                <div style={{ backgroundColor: '#E5EBF7'}} className="main">
                    <Header />
                    <Outlet></Outlet>
                </div>
                <IdleTimerComponent />
            </div>
        );
    }
}

export default Main;